import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import { formatImage } from 'ThreeTerminal_base/publicMethod';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import { h5PageCount } from 'ThreeTerminal_utils';
import styles from './index.css';

class FeedItem extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    clickHandle = (isSendCount = true, isJumpQQlink = false, isCall = true) => {
        const {
            content: { columnId, isCurrentItem, base62Id, currentYear },
        } = this.props;

        if (isCurrentItem) {
            return false;
        }

        h5PageCount([
            {
                behavior: 'action',
                type: 'phtv_relate',
                other: {},
            },
        ]);

        if (isCall) {
            callApp({
                docType: 'phtvsolenewslist',
                pid: columnId,
                videoId: base62Id,
                year: currentYear,
                kind: 'inter_fhwslmsp02',
                noKindFrom: 1,
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1505848733132',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8887',
                isJumpQQlink,
            });
        }
    };

    render() {
        const {
            content: { time, isCurrentItem, title, imageUrl, comment, base62Id, currentYear, columnId },
        } = this.props;
        const dataTime = (time && time.split(' ') && time.split(' ')[0]) || '';
        const month = (dataTime && dataTime.split('/') && dataTime.split('/')[1]) || '';
        const day = (dataTime && dataTime.split('/') && dataTime.split('/')[2]) || '';
        let timeStr = '';

        if (month && day) {
            timeStr = `${month}-${day}期`;
        }
        const schemeLink = getSchemeLink({
            docType: 'phtvsolenewslist',
            pid: columnId,
            videoId: base62Id,
            year: currentYear,
            kind: 'inter_fhwslmsp02',
            noKindFrom: 1,
        });

        return (
            <div className={styles.feedItem} onClick={this.clickHandle}>
                {imageUrl && (
                    <div className={styles.feedImg}>
                        <LazyImg
                            // src={formatImage(imageUrl.replace(/\.webp|_webp/g, ''), 224, 150)}
                            src={formatImage(imageUrl.replace(/(?<=\.png|\.jpg|\.jpeg|\.gif)\.webp|_webp/g, ''), 224, 150)}
                            placeholder="https://x0.ifengimg.com/cmpp/2019/1014/imgload.png"
                        />
                    </div>
                )}
                <div className={styles.feedText}>
                    <div className={`${styles.feedTitle} ${isCurrentItem ? styles.active : ''}`}>{title}</div>
                    <div className={styles.feedInfo}>
                        {!isCurrentItem && <div className={styles.feedInfoRead}>打开APP阅读</div>}
                        {timeStr && <div className={styles.feedInfoMark}>{timeStr}</div>}
                        {comment && <div className={styles.feedInfoMark}>{comment}评</div>}
                    </div>
                </div>
                {!isCurrentItem && (
                    <WxLaunchApp
                        launchType="app"
                        launchAppClick={this.clickHandle.bind(this, true, false, false)}
                        schemeLink={schemeLink}
                        launchAppFail={this.clickHandle.bind(this, false, true, true)}
                    />
                )}
            </div>
        );
    }
}

export default errorBoundary(FeedItem);
